// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__xXggy","loading":"Loading_loading__xklYp","placeHolderShimmer":"Loading_placeHolderShimmer__g98+G"};